import { Component, EventEmitter, Output, Inject, OnDestroy } from '@angular/core';
import { OnInit } from "@angular/core";
import { Router } from "@angular/router";


import { config } from "../../../../../config/index";

import { SharedService } from "../../services/shared.service";
import { SessionStorageService } from '../../services/session-storage.service';


@Component({
    selector: 'payment-menu',
    template: require('./payment-menu.component.html'),
    styles: [require('./payment-menu.component.less')],
    providers: [SharedService, SessionStorageService],
    preserveWhitespaces: true
})

export class PaymentMenuComponent implements OnInit, OnDestroy {

    @Output() paymentMenuEvent: EventEmitter<any> = new EventEmitter<any>();

    private _role = config.role;
    private _userRole: string;
    private locatManager: string;
    private cooAdmin: string;
    private ctAdmin: string;

    constructor(
        private _sharedService: SharedService,
        private _sessionStorageService: SessionStorageService,
        private _router: Router,
        @Inject('utilService') private utilService: any
    ) {
    }

    /** Fetching user role **/
    userRoleFetch = () => {
        this._sessionStorageService.readItem(this._role).then((data: any) => {
            this._userRole = data.role
        });
    }

    navigate = (path: any) => {
        this._router.navigate([path]);
    }

    searchItem = (searchKey: any) => {
        this.paymentMenuEvent.emit(searchKey);
    }

    ngOnInit() {
        this.locatManager = config.location_manager;
        this.cooAdmin = config.coo_admin;
        this.ctAdmin = config.ct_admin;
        this.utilService.hideHeaderNavDropDownNotSubscribed.next({ opened: true });
        this.userRoleFetch();
    }

    ngOnDestroy() {
        this.utilService.hideHeaderNavDropDownNotSubscribed.next({ opened: false });
    }
}

